import * as tslib_1 from "tslib";
import { FilterType, FilterTypeFromFetch, } from '../types/types';
import { ColorFilterModel } from '../models/ColorFilterModel';
import { ListFilterModel } from '../models/ListFilterModel';
import { PriceFilterModel } from '../models/PriceFilterModel';
import { CollectionFiltersService } from '../services/CollectionFiltersService';
import { FiltersApi } from '../api/FiltersApi';
import _ from 'lodash';
var FiltersStore = /** @class */ (function () {
    function FiltersStore(siteStore, mainCollectionId, filterConfigsService) {
        this.mainCollectionId = mainCollectionId;
        this.filterConfigsService = filterConfigsService;
        this.filterModels = [];
        this.snapshot = [];
        this.collectionFiltersService = new CollectionFiltersService(this.mainCollectionId, this.filterConfigsService);
        this.filtersApi = new FiltersApi(siteStore);
    }
    FiltersStore.prototype.fetchFilters = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var filterTypeDTOs, filtersResponse, filters;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filterTypeDTOs = this.filterConfigsService.getFilterTypeDTOs();
                        return [4 /*yield*/, this.filtersApi.getFilters(filterTypeDTOs, this.mainCollectionId)];
                    case 1:
                        filtersResponse = _a.sent();
                        filters = this.removeCollectionFiltersWithNoOptions(filtersResponse.data.catalog.filters);
                        this.removeCustomCollectionFiltersWithNoOptions(filtersResponse.data.catalog.filters);
                        this.filterModels = this.sortFilterModels(this.createFilterModels(filters));
                        return [2 /*return*/, this.filterModels];
                }
            });
        });
    };
    FiltersStore.prototype.updateActiveFilterOption = function (filterId, selectionValue) {
        var filterModel = this.filterModels.find(function (fm) { return fm.filterId === filterId; });
        filterModel.updateActiveOptions(selectionValue);
    };
    FiltersStore.prototype.getFilterDTOs = function () {
        var filtersDTO = [];
        filtersDTO.push(this.getCollectionFilterDTO());
        filtersDTO.push.apply(filtersDTO, this.getNonCollectionFilterDTOs());
        return filtersDTO;
    };
    FiltersStore.prototype.getFilterModels = function () {
        return this.filterModels;
    };
    FiltersStore.prototype.getDefaultFilterDTO = function () {
        return this.collectionFiltersService.getDefaultFilterDTO();
    };
    FiltersStore.prototype.getCollectionIdsFilterDTO = function () {
        var collectionIdsFilter = { mainCategory: this.mainCollectionId };
        if (this.isFilterModelExists(FilterType.COLLECTION) &&
            this.getSelectedCollectionFilterId() !== this.mainCollectionId) {
            collectionIdsFilter.subCategory = this.getSelectedCollectionFilterId();
        }
        if (this.hasSelectedCustomCollectionIds()) {
            collectionIdsFilter.customCategories = this.getSelectedCustomCollectionIds();
        }
        return collectionIdsFilter;
    };
    FiltersStore.prototype.getSelectedCollectionFilterId = function () {
        return this.getFilterModelByType(FilterType.COLLECTION)[0].activeOptions;
    };
    FiltersStore.prototype.getSelectedCustomCollectionIds = function () {
        var customCollectionFilterModels = this.getFilterModelByType(FilterType.CUSTOM_COLLECTION);
        return customCollectionFilterModels.filter(function (fm) { return fm.hasActiveOptions(); }).map(function (fm) { return fm.activeOptions; });
    };
    FiltersStore.prototype.hasSelectedCustomCollectionIds = function () {
        var result = false;
        var customCollectionFilterModels = this.getFilterModelByType(FilterType.CUSTOM_COLLECTION);
        customCollectionFilterModels.forEach(function (fm) {
            if (fm.hasActiveOptions()) {
                result = true;
            }
        });
        return result;
    };
    FiltersStore.prototype.resetFilters = function () {
        this.filterModels.forEach(function (fm) {
            fm.resetActiveOptions();
        });
    };
    FiltersStore.prototype.updateSnapshotWithActiveOptions = function () {
        this.snapshot = this.filterModels.map(function (fm) { return _.cloneDeep(fm.activeOptions); });
    };
    FiltersStore.prototype.updateActiveOptionsWithSnapshot = function () {
        var _this = this;
        this.snapshot.forEach(function (activeOptions, i) {
            _this.filterModels[i].activeOptions = _.cloneDeep(activeOptions);
        });
    };
    FiltersStore.prototype.shouldShowClearFilters = function () {
        return !this.isOnlyDefaultFilterSelected();
    };
    FiltersStore.prototype.getSelectedFilterTypes = function () {
        return this.filterModels.filter(function (fm) { return fm.hasActiveOptions(); }).map(function (fm) { return fm.filterType; });
    };
    FiltersStore.prototype.removeCollectionFiltersWithNoOptions = function (filters) {
        var _this = this;
        _.remove(filters, function (filter) {
            return (filter.filterType === FilterTypeFromFetch.CATEGORY &&
                _this.collectionFiltersService.getEnabledCollectionFilterOptions(filter.values).length === 0);
        });
        return filters;
    };
    FiltersStore.prototype.removeCustomCollectionFiltersWithNoOptions = function (filters) {
        var customCollectionFilter = filters.find(function (f) { return f.filterType === FilterTypeFromFetch.FILTERED_CATEGORIES; });
        if (customCollectionFilter) {
            this.filterConfigsService.removeCustomCollectionFiltersWithNoOptions(customCollectionFilter.values);
        }
    };
    FiltersStore.prototype.isFilterModelExists = function (filterType) {
        return !!this.filterModels.find(function (fm) { return fm.filterType === filterType; });
    };
    FiltersStore.prototype.isOnlyDefaultFilterSelected = function () {
        return this.getFilterDTOs().length === 1 && _.isEqual(this.getDefaultFilterDTO(), this.getFilterDTOs()[0]);
    };
    FiltersStore.prototype.getFilterModelByType = function (filterType) {
        return this.filterModels.filter(function (fm) { return fm.filterType === filterType; });
    };
    FiltersStore.prototype.createFilterModels = function (filters) {
        var _this = this;
        var assignFilterId = function (filterModel, index) {
            filterModel.filterId = index;
            return filterModel;
        };
        var flatten = function (acc, curr) { return acc.concat(curr); };
        return filters
            .map(function (filter) {
            switch (filter.filterType) {
                case FilterTypeFromFetch.CATEGORY: {
                    return _this.collectionFiltersService.createCollectionFilterModel(FilterType.COLLECTION, filter.values);
                }
                case FilterTypeFromFetch.FILTERED_CATEGORIES: {
                    return _this.collectionFiltersService.createCustomCollectionFilterModels(FilterType.CUSTOM_COLLECTION, filter.values);
                }
                case FilterTypeFromFetch.COLOR: {
                    return new ColorFilterModel(FilterType.COLOR_OPTION, filter.name, filter.values, filter.field);
                }
                case FilterTypeFromFetch.LIST: {
                    return new ListFilterModel(FilterType.LIST_OPTION, filter.name, filter.values, filter.field);
                }
                case FilterTypeFromFetch.PRICE: {
                    var title = _this.filterConfigsService.getFilterConfigTitle(FilterType.PRICE);
                    return new PriceFilterModel(FilterType.PRICE, title, filter.values);
                }
            }
        })
            .reduce(flatten, [])
            .map(assignFilterId);
    };
    FiltersStore.prototype.sortFilterModels = function (filterModels) {
        this.filterModels = this.sortColorAndListFiltersAlphabetically(filterModels);
        var sortingOrder = [
            FilterType.COLLECTION,
            FilterType.PRICE,
            FilterType.COLOR_OPTION,
            FilterType.LIST_OPTION,
            FilterType.CUSTOM_COLLECTION,
        ];
        return _.sortBy(this.filterModels, function (fm) {
            return sortingOrder.indexOf(fm.filterType);
        });
    };
    FiltersStore.prototype.sortColorAndListFiltersAlphabetically = function (filterModels) {
        return _.sortBy(filterModels, function (fm) {
            if (fm.filterType === FilterType.COLOR_OPTION || fm.filterType === FilterType.LIST_OPTION) {
                return fm.title;
            }
        });
    };
    FiltersStore.prototype.isCollectionFilter = function (filter) {
        return filter.filterType === FilterType.CUSTOM_COLLECTION || filter.filterType === FilterType.COLLECTION;
    };
    FiltersStore.prototype.getCollectionFilterDTO = function () {
        return this.collectionFiltersService.toDTO();
    };
    FiltersStore.prototype.getNonCollectionFilterDTOs = function () {
        var _this = this;
        var nonCollectionFilterModels = this.filterModels.filter(function (fm) { return !_this.isCollectionFilter(fm); });
        return nonCollectionFilterModels
            .filter(function (fm) { return fm.hasActiveOptions(); })
            .map(function (fm) { return fm.toDTO(); });
    };
    return FiltersStore;
}());
export { FiltersStore };
//# sourceMappingURL=FiltersStore.js.map